import { MMLScene } from "@mml-io/mml-web";
import { StandaloneThreeJSAdapter } from "@mml-io/mml-web-threejs-standalone";
import * as THREE from "three";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";

import { NonInteractiveMMLScene } from "~/library/mml/NonInteractiveMMLScene";

export const defaultClientScene = async (
  scene:
    | MMLScene<StandaloneThreeJSAdapter>
    | NonInteractiveMMLScene<StandaloneThreeJSAdapter>,
  showGroundPlane: boolean = true,
) => {
  const threeScene = scene.getGraphicsAdapter().getThreeScene();

  threeScene.background = new THREE.Color(0xeeeeee);

  const floorGeometry = new THREE.PlaneGeometry(2000, 2000, 100, 100);
  floorGeometry.rotateX(-Math.PI / 2);
  const floor = new THREE.Mesh(
    floorGeometry,
    new THREE.MeshBasicMaterial({
      color: 0xeeeeee,
      side: THREE.DoubleSide,
    }),
  );
  floor.position.y = -0.02;
  floor.visible = showGroundPlane;
  threeScene.add(floor);

  const gridHelper = new THREE.GridHelper(2000, 2000, 0xcccccc, 0xcccccc);
  gridHelper.visible = showGroundPlane;
  threeScene.add(gridHelper);

  const fog = new THREE.Fog(0xeeeeee, 25, 100);
  threeScene.fog = fog;

  const ambient = new THREE.AmbientLight(0xcccccc, 0.3);
  threeScene.add(ambient);

  const hdrLoader = new RGBELoader();
  const envMap = await hdrLoader.loadAsync("/ue4sky.hdr");
  envMap.mapping = THREE.EquirectangularReflectionMapping;
  threeScene.environment = envMap;

  return { floor, gridHelper };
};

export const defaultEditScene = async (
  scene:
    | MMLScene<StandaloneThreeJSAdapter>
    | NonInteractiveMMLScene<StandaloneThreeJSAdapter>,
) => {
  const threeScene = scene.getGraphicsAdapter().getThreeScene();

  threeScene.background = new THREE.Color(0x222222);

  const gridHelper = new THREE.GridHelper(20, 20, 0x666666, 0x444444);
  threeScene.add(gridHelper);

  const hdrLoader = new RGBELoader();
  const envMap = await hdrLoader.loadAsync("/ue4sky.hdr");
  envMap.mapping = THREE.EquirectangularReflectionMapping;
  threeScene.environment = envMap;
};
